"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const css_1 = require("@emotion/css");
const __theme_1 = __importDefault(require("./_.theme"));
exports.default = {
    container: (0, css_1.css)({
        marginLeft: '10px',
    }),
    heading: (0, css_1.css)({
        color: __theme_1.default.base00,
        padding: '10px',
        margin: '44px 0 0 0',
        background: __theme_1.default.base03,
        fontSize: '15px',
        textTransform: 'uppercase',
    }),
    select: (0, css_1.css)({
        textAlign: 'right',
    }),
    icon: (0, css_1.css)({
        marginTop: '-3px',
    }),
    controls: {
        button: (0, css_1.css)({
            'borderRadius': 0,
            'width': '25%',
            'display': 'block',
            'float': 'left',
            'fontSize': '20px',
            'padding': '3px 0 6px 0',
            'background': __theme_1.default.base01,
            'color': __theme_1.default.base00,
            ':hover': {
                background: __theme_1.default.base03,
                color: __theme_1.default.base00,
            },
            ':hover g': {
                color: __theme_1.default.base00,
            },
        }),
        icon: (0, css_1.css)({
            color: __theme_1.default.base00,
        }),
        iconOptionsActive: (0, css_1.css)({
            'color': __theme_1.default.base0B,
            ':hover': {
                color: __theme_1.default.base00,
            },
        }),
    },
};
